import { cva } from 'class-variance-authority';
import { type IconName, Icon, Typography } from './';

const alertVariants = cva('flex gap-md p-4 border rounded-sm', {
  variants: {
    variant: {
      info: 'bg-information-100 border-information-200 text-information',
      warning: 'bg-warning-100 border-warning text-warning',
      error: 'bg-error-50 border-error text-error',
      success: 'bg-success-50 border-success text-success',
    },
  },
});

export type AlertProps = {
  variant: 'info' | 'warning' | 'error' | 'success';
  icon: IconName;
  title?: string;
  children: React.ReactNode;
};

export function Alert({ variant, icon, title, children }: AlertProps) {
  return (
    <div className={alertVariants({ variant })}>
      <Icon name={icon} size={19} className="shrink-0 mt-1 text-inherit" />
      <div className="alert-content">
        {title && (
          <Typography variant="h6" className="text-secondary-500">
            {title}
          </Typography>
        )}
        <Typography variant="h6" className="text-secondary-500 text-pretty">
          {children}
        </Typography>
      </div>
    </div>
  );
}
